<template>
  <div class="mt-8 flex justify-center content-center">
    <i class="fas fa-spinner fa-spin"></i>
  </div>
</template>

<script>
import config from '@/config'
import util from '@/util'

export default {
  mounted() {
    const redirectUrl = util.getParamValue('redirectUrl')

    const scopes = [
      'https://www.googleapis.com/auth/userinfo.email',
      'https://www.googleapis.com/auth/userinfo.profile',
    ]

    // Function to manually create a query string
    const toQueryString = (params) => {
      return Object.keys(params)
        .map((key) => `${encodeURIComponent(key)}=${encodeURIComponent(params[key])}`)
        .join('&')
    }

    let googleRedirect = `${config.presenterDomain}/google-auth?provider=google`
    if (config.integrationPlatform === 'GoogleSlide' || redirectUrl) {
      googleRedirect = config.googleSlideWebUrl || redirectUrl
    }

    const params = {
      client_id: config.googleClientId,
      redirect_uri: googleRedirect,
      scope: scopes.join(' '),
      response_type: 'code',
      access_type: 'offline',
      prompt: 'consent',
    }
    const oauth2Url = `https://accounts.google.com/o/oauth2/v2/auth?${toQueryString(params)}`

    window.location.href = oauth2Url
  },
}
</script>
